module.exports = __webpack_public_path__ + "96449b5b4789acd3eb4cb0c7bd8de7e8.svg";